<template>
  <div class="market-giftCouponList-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <auth-button auth="market:coupon:gift:template:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 创建礼品券</el-button>
      </auth-button>
      <auth-button auth="market:coupon:gift:code:template:get">
        <el-button class="down-btn mr10" @click="onDownloadTemplate" :loading="downloadLoading" >下载券码模板</el-button>
      </auth-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #name="{ row }">{{ row.name }}</template>
      <template #subTitle="{ row }">{{ row.subTitle }}</template>
      <template #imageUrl="{ row }">
        <img class="img" :src="row.imageUrl" alt="">
      </template>
      <template #useTime="{ row }">{{ row.useTime }}</template>
      <template #issueType="{ row }">{{ issueTypeMap[row.issueType] || '---' }}</template>
      <template #stock="{ row }">{{ row.stock ? row.stock : (row.stock === 0 ? 0 :'---') }}</template>
      <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
      <template #description="{ row }">
        <el-button v-if="row.description" type="text" @click="onLookRemark(row)">查看使用须知</el-button>
        <span v-else>---</span>
      </template>
      <template #operation="{ scope }">
       <auth-button auth="market:coupon:gift:template:update">
        <el-button type="text" v-if="scope.row.disable"  class="edit mr10"  @click="onEdit(scope.row)">编辑</el-button>
       </auth-button>
        <auth-button auth="market:coupon:gift:template:discard">
        <el-button v-if="!scope.row.disable" class="del" type="text" @click="onChangeStatus(scope.row)">停用</el-button>
        <el-button v-if="scope.row.disable"  type="text" @click="onChangeStatus(scope.row)">启用</el-button>
      </auth-button>
        <auth-button auth="market:coupon:gift:template:create">
          <el-button type="text" class="edit ml10" @click="onEdit(scope.row, true)">复制</el-button>
        </auth-button>
        <auth-button auth="market:coupon:gift:code:create" v-if="scope.row.issueType == 'Stock'">
          <el-button type="text" class="edit ml10" @click="onImportCode(scope.row)">导码</el-button>
        </auth-button>
      </template>
    </Table>
    <el-dialog :visible="isShowRemarkDialog" title="使用须知" :before-close="() => this.isShowRemarkDialog = false" width="30%">
      <div class="remark-box" v-html="currentRow.description"></div>
    </el-dialog>
    <input v-if="showImport" ref="code-import-input" @change="importInputChange" class="code-import-input" type="file" accept=".xls, .xlsx">
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { api_getGiftCouponList, api_putUpdatestatusGiftCoupon, api_getCouponCodeTemplate, api_postCodeImport} from '@/api/market'
import { downFile } from "@/utils";
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "marketGiftCouponListIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "礼品券名称",
          placeholder: "请输入礼品券名称",
          type: "input",
          key: "name",
        },
      ],
      form: {},
      tableThData: [
        { prop: "name", label: "礼品券名称", minWidth: "180", },
        { prop: "subTitle", label: "标题", minWidth: "110", },
        { prop: "imageUrl", label: "图片", minWidth: "110", },
        { prop: "useTime", label: "券有效时间", minWidth: "160", },
        { prop: "issueType", label: "券来源", minWidth: "160", },
        { prop: "stock", label: "券码数量", minWidth: "160", },
        { prop: "useRangeType", label: "核销范围", minWidth: "120", },
        { prop: "description", label: "使用须知", minWidth: "120", },
        { prop: "operation", label: "操作", minWidth: "180", },
      ],
      isShowRemarkDialog: false,
      currentRow: {},
      downloadLoading: false,
      currentRowImport: {},
      showImport: false,
      issueTypeMap: {
        'Auto': '闰土自制',
        'Stock': '库存发放',
      },
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      const data = await api_getGiftCouponList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
      this.showImport = true
    },

    // 点击编辑
    async onEdit(row, copy='') {
      this.$router.push({
        path: `/market/giftCouponList/add?id=${row.id}&copy=${copy}`
      });
    },

    // 点击创建按钮
    onAdd() {
      this.$router.push({
        path: "/market/giftCouponList/add"
      });
    },

    // 查看使用须知
    onLookRemark(row) {
      this.currentRow = row
      this.isShowRemarkDialog = true
    },

         // 更改券状态
     onChangeStatus(row) {
      this.$baseConfirm(
      row.disable ? '是否确认启用该礼品券？' : '是否停用该礼品券？',
         { title: '提示', type: 'warning', },
         async () => {
        await api_putUpdatestatusGiftCoupon({id: row.id})
           this.$baseMessage('操作成功', 'success')
           this.getList()
         }
      )
    },
    // 下载券码导入模板
    async onDownloadTemplate() {
      this.downloadLoading = true
      try {
        let res = await api_getCouponCodeTemplate()
        downFile(res)
        this.downloadLoading = false
      } catch (err) {
        console.log('line:151 err: ', err);
        this.downloadLoading = false
      }
    },
    // 导入券码
    onImportCode(row) {
      this.currentRowImport = row
      this.$refs['code-import-input'].click()
    },
    // 上传input改变事件
    async importInputChange(e) {
      try {
        const files = e.target.files
        let res = await api_postCodeImport({
          id: this.currentRowImport.id,
          file: files[0]
        })
        this.$baseMessage('导码成功', 'success')
        this.showImport = false
        this.getList()
      } catch (err) {
        console.log('err: ', err);
        this.showImport = false
        this.getList()
      }
    }
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-giftCouponList-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  .code-import-input {
    height: 0px;
    visibility: hidden;
  }
  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }

  .fun-btn-box {
    margin-top: 20px;
  }

  .img {
    width: 50px;
    height: 50px;
  }

  .del {
    color: #F74A4A;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>
